import { getAccessToken } from '../../services/localStorage/localStorageService';

export function getAndSetAccessToken(setOauthToken: Function) {
  setOauthToken(getAccessToken());
}
